var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaloriesSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 11",
    d: "M68 34C68 52.7777 52.7777 68 34 68C15.2223 68 0 52.7777 0 34C0 15.2223 15.2223 0 34 0C52.7777 0 68 15.2223 68 34ZM8.5 34C8.5 48.0833 19.9167 59.5 34 59.5C48.0833 59.5 59.5 48.0833 59.5 34C59.5 19.9167 48.0833 8.5 34 8.5C19.9167 8.5 8.5 19.9167 8.5 34Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 10",
    d: "M34 4.25C34 1.90278 35.9101 -0.0273682 38.239 0.26528C42.1035 0.750883 45.8666 1.89831 49.3601 3.66739C54.1214 6.07845 58.2482 9.57647 61.4066 13.8784C64.5651 18.1804 66.6664 23.1655 67.5407 28.4303C68.415 33.6951 68.0376 39.0918 66.4391 44.1837C64.8405 49.2756 62.0658 53.9197 58.3394 57.7402C54.6129 61.5607 50.0394 64.4503 44.989 66.1752C39.9385 67.9001 34.5529 68.4119 29.2679 67.6691C25.3901 67.1241 21.6464 65.9149 18.1977 64.1046C16.1194 63.0137 15.6552 60.3382 16.9967 58.4121C18.3383 56.4861 20.9772 56.0492 23.0991 57.0526C25.4174 58.1488 27.8954 58.8926 30.4509 59.2518C34.4146 59.8089 38.4539 59.4251 42.2417 58.1314C46.0296 56.8377 49.4597 54.6705 52.2545 51.8051C55.0494 48.9397 57.1304 45.4567 58.3293 41.6378C59.5282 37.8188 59.8112 33.7713 59.1555 29.8227C58.4998 25.8741 56.9238 22.1353 54.555 18.9088C52.1861 15.6824 49.091 13.0588 45.5201 11.2505C43.2178 10.0847 40.7593 9.2788 38.2304 8.85335C35.9157 8.46395 34 6.59721 34 4.25Z",
    fill: "#FF5E71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fire-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3906 45.3125C29.0311 45.3125 24.6875 40.7908 24.6875 35.7148C24.6875 34.5361 24.7137 33.5793 25.5312 32.6562C25.4427 33.1912 26.71 37.7652 30.8511 37.5255C30.6714 34.0501 29.7314 25.5358 34.097 22.5928C33.7114 27.22 34.8446 33.4359 39.8995 34.3438C39.6101 32.4883 39.6447 29.4019 40.944 28.8315C41.0841 31.6741 43.1859 33.4274 43.1859 36.1595C43.1859 41.1073 38.3993 45.3125 34.3906 45.3125ZM42.3261 25.8666C38.6262 26.9213 37.9487 29.9124 38.1875 31.8125C35.5483 28.7092 35.6562 25.141 35.6562 20C27.1918 23.1919 29.1602 32.393 28.9062 35.1875C26.7775 33.4452 26.375 29.2812 26.375 29.2812C24.1272 30.438 23 33.5262 23 36.0312C23 42.0894 27.9106 47 33.9688 47C40.0269 47 44.9375 42.0894 44.9375 36.0312C44.9375 32.431 42.294 30.7705 42.3261 25.8666Z",
    fill: "#FF5E71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaloriesSvg);
export default __webpack_public_path__ + "static/media/caloriesSvg.e357e2c3b68d1b3347acfa3e7c8ac264.svg";
export { ForwardRef as ReactComponent };